<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click="onClick">
    <img src="~@/assets/img/CITEditor/indent.svg" alt="text indent" title="text indent" />
  </button>
</template>

<script>
export default {
  name: 'TextIndent',
  props: [
    'active'
  ],
  methods: {
    onClick () {
      document.execCommand('indent', false)
    }
  }
}
</script>
